// Vuetify
import 'vuetify/styles'
import { createVuetify, ThemeDefinition } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

const myCustomLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#f5f5f5',
    primary: '#3376D2',
    secondary: '#FFC107',
    accent: '#8c9eff',
    error: '#b71c1c',
    warning: '#FFC107',
    info: '#2196f3',
    success: '#4caf50',
    anchor: '#1976D2',
    surface: '#FFFFFF',
    onSurface: '#000000',
    onError: '#FFFFFF',
  }
}

export default createVuetify({
  components,
  directives,
  // icons: {
  //   defaultSet: 'mdi',
  //   aliases,
  //   sets: {
  //     mdi,
  //   }
  // },
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme
    },
  },
})